import React from 'react';
import { HeaderTableCell, TableRow } from '../InsuranceStyles';

export const InsuranceTableHeader = () => (
  <TableRow>
    <HeaderTableCell>Description</HeaderTableCell>
    <HeaderTableCell>Owner</HeaderTableCell>
    <HeaderTableCell>Insured</HeaderTableCell>
    <HeaderTableCell style={{ minWidth: '200px' }}>Beneficiaries</HeaderTableCell>
    <HeaderTableCell style={{ textAlign: 'right' }}>Annual Premium</HeaderTableCell>
    <HeaderTableCell style={{ textAlign: 'right' }}>Cash Value</HeaderTableCell>
    <HeaderTableCell style={{ textAlign: 'right' }}>Death Benefit</HeaderTableCell>
    <HeaderTableCell>Premium Paid</HeaderTableCell>
  </TableRow>
);
